import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Sparkles, Lock, Mail } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="mt-16 border-t border-[#141021] dark:border-[#2A2440] bg-[#15102A] text-white">
      <div className="max-w-6xl mx-auto px-5 py-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2">
              <img src="/uc-box-purple.png" alt="unboxcases" className="h-9 w-auto object-contain" draggable={false} />
              <div className="font-cases uppercase text-xl tracking-tight">unbox<span className="text-transparent bg-clip-text bg-gradient-to-r from-[#A78BFA] to-[#7C3AED]">cases</span></div>
            </div>
            <p className="text-xs text-white/50 mt-2 leading-relaxed">Open real mystery cases, battle live, and cash out or ship what you win. Provably fair, always.</p>
            <div className="mt-4 inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wide bg-white/10 px-2.5 py-1 rounded-full">
              <ShieldCheck className="h-3.5 w-3.5 text-[#22C55E]" /> 18+ Only
            </div>
          </div>

          <div>
            <div className="text-[11px] font-bold uppercase tracking-wide text-white/40 mb-3">Play</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li className="flex items-center gap-2"><Sparkles className="h-3.5 w-3.5 text-[#8B5CF6]" /> Open Cases</li>
              <li className="flex items-center gap-2"><Sparkles className="h-3.5 w-3.5 text-[#8B5CF6]" /> Case Battles</li>
              <li className="flex items-center gap-2"><Sparkles className="h-3.5 w-3.5 text-[#8B5CF6]" /> Free Demo Spins</li>
            </ul>
          </div>

          <div>
            <div className="text-[11px] font-bold uppercase tracking-wide text-white/40 mb-3">Trust</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li className="flex items-center gap-2"><Lock className="h-3.5 w-3.5 text-[#22D3EE]" /> Provably Fair Draws</li>
              <li className="flex items-center gap-2"><Lock className="h-3.5 w-3.5 text-[#22D3EE]" /> Secure Card Deposits</li>
              <li className="flex items-center gap-2"><Lock className="h-3.5 w-3.5 text-[#22D3EE]" /> 100% Sell-Back Value</li>
            </ul>
          </div>

          <div>
            <div className="text-[11px] font-bold uppercase tracking-wide text-white/40 mb-3">Support</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href="mailto:unboxcasessupport@gmail.com" className="flex items-center gap-2 hover:text-white transition-colors"><Mail className="h-3.5 w-3.5" /> Contact us</a></li>
              <li><a href="mailto:unboxcasessupport@gmail.com?subject=Becoming%20an%20unboxcases%20affiliate" className="hover:text-white transition-colors">Affiliates</a></li>
              <li className="text-white/50">Live chat in your profile</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="text-xs text-white/40">© {year} unboxcases™. All rights reserved. All trademarks and brand names shown are the property of their respective owners and are used for identification only.</div>
          <div className="text-[11px] text-white/40 flex items-center gap-4">
            <span>Terms</span><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white transition-colors">Privacy</Link><span>Responsible Gaming</span>
          </div>
        </div>
        <p className="mt-4 text-[10px] text-white/30 leading-relaxed">Gambling can be addictive. Play responsibly and only wager what you can afford to lose. unboxcases is intended for entertainment by adults aged 18 and over. If you or someone you know has a gambling problem, please seek help.</p>
      </div>
    </footer>
  );
}
